/// <reference path="../../global/fn.js" />

(function ($) {
    $.widget("nsp.w_servicesCardsCarousel", {
        options: {
            slickOptions: {
                arrows: true,
                infinite: false,
                slidesToShow: 4,
                slidesToScroll: 3,
                dots: false,
                rows: 0,
                responsive: [
                    {
                        breakpoint: api.vars.scr.phoneSmall,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                ],
                appendArrows: jQuery(".s-services-cards__toolbar  .b-slick-arrows"),
            },
        },

        _create: function () {
            const self = this;
            self.wrap = self.element.find(".s-services-cards__list");

            self.initSlider();

            $(window).on("resize", () => {
                self.initSlider();
            });
        },

        initSlider: function () {
            const self = this;

            if (!self.wrap.hasClass("slick-initialized")) {
                self.wrap.each((indx, el) => {
                    $(el)
                        .on("init", (slick) => {})
                        .slick(self.options.slickOptions);
                });
            }
        },
    });
})(jQuery);
